<template>
  <div class="company-clients">
    <!-- list clients -->
    <div class="company-clients-content">
      <div class="company-clients-content-header">
        <TText large value="COMPANY.clients" />
        <v-btn class="ma-1" icon @click="$router.push({ name: 'CompanyClientsDetails', params: { client_id: 'create' }})">
          <TIcon size="24" name="sign-plus"/>
        </v-btn>
      </div>
      <div class="company-client-content-list">
        <ClickableListItem v-for="client in clients" :key="`${client.id}clients`" :id="client.id"
          :is_selected="client.id == selected_client.id" :margin="2" :is_completely_clickable="true" background_color="#121212"
          foreground_color="#fff" @emittedClick="$router.push({ name: 'CompanyClientsCallbacks', params: { client_id: client.id }})">

          <template #front>
            <TIcon size="24" :name="client.activated ? 'checkbox-radial-filled' : 'checkbox-radial-empty'" />
          </template>

          <template #descriptor> {{ client.name }}</template>

        </ClickableListItem>
      </div>
    </div>
    <div class="company-clients-seperator"></div>
    <router-view></router-view>
  </div>
</template>

<script>

import { CompanyClientsMixin } from '@/mixins/CompanyClients.mixin.js'
export default {
  name: 'CompanyClients',
  components: {

  },
  mixins: [CompanyClientsMixin],
  data: function () {
    return {

    }
  },
  created() {
    this.requestUObject({
      url: [
        { businesses: this.getBusiness.id },
        { clients: '' },
        { showWithEntitiesNormalized: '' },
      ]
    })
    
  },
  computed: {
    
    

  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
.company-clients {
  position: relative;
  width: 100%;
  display: flex;
  overflow: hidden;
  // padding: 5px;
}

.company-clients-content-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.company-clients-seperator {
  background-color: #fff !important;
  border-color: #fff !important;
  // background-color: #000!important;
  // border-color: #000!important;
  position: relative;
  display: flex;
  flex-shrink: 0;
  height: calc(100% - 10px);
  top: 5px;
  width: 1px;
  opacity: .2;
}

.company-clients-content {
  display: flex;
  flex-direction: column;
  // background-color: blue;
  padding-left: 10px;
  padding-right: 10px;
  width: 400px;
}

.company-client-content-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  overflow-y: auto;
  overflow-x: hidden;
}

.company-clients-content-body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  grid-gap: 10px;
  max-width: 400px !important;
}

</style>
